import * as React from "react";
import Box from "@mui/material/Box";
import { Nav } from "./Elements";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSelector } from "react-redux";
import { getlogo } from "./navSlice";
import { getUserName } from "../../Authentication/authSlice";
import { useNavigate } from "react-router-dom";

export default function QENavbar() {
  const showLogo = useSelector(getlogo);
  const user_name = useSelector(getUserName);

  return (
    <Nav>
      <Box sx={{ display: "flex", alignItems: "center", height: "100%", px: "16px" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {showLogo ? <img src="/assets/tjommie-logo.svg" height="24" alt="Tjommie" style={{ display: "block" }} /> : <Backbutton />}
        </Box>
        <Box sx={{ flex: 1 }} />
        <Box sx={{ textAlign: "right" }}>
          <Typography sx={{ fontSize: "0.62rem", color: "rgba(255,255,255,0.35)", lineHeight: 1, letterSpacing: "0.05em" }}>
            QE
          </Typography>
          <Typography sx={{ fontSize: "0.88rem", color: "#fff", fontWeight: 700, lineHeight: 1.3 }}>
            {user_name}
          </Typography>
        </Box>
      </Box>
    </Nav>
  );
}

function Backbutton() {
  const navigate = useNavigate();
  return (
    <ArrowBackIcon onClick={() => navigate(-1)} sx={{ color: "rgba(255,255,255,0.7)", cursor: "pointer", fontSize: "1.3rem" }} />
  );
}
